import { Link } from 'react-router-dom';
import { WHATSAPP_CONFIG } from '../lib/whatsapp';

// Fresh Leaf footer: a dark rounded tile inside the page gutter, with the
// "wonder herbals" wordmark bleeding off its bottom edge.

const COLS = [
  {
    heading: 'Shop',
    items: [
      ['All products',   '/shop'],
      ['Hair care',      '/collection/hair-care'],
      ['Skin care',      '/collection/skin-care'],
      ['Wellness',       '/collection/wellness'],
      ['Shuddh herbs',   '/collection/herbs'],
      ['Essential oils', '/collection/essential-oils'],
    ],
  },
  {
    heading: 'Discover',
    items: [
      ['Prakriti check',    '/ayurveda/dosha-quiz'],
      ['Ritucharya seasons', '/ritucharya'],
      ['Ingredient library', '/ingredients'],
      ['Shop by concern',   '/concerns'],
      ['Ayurveda 101',      '/ayurveda'],
      ['Journal',           '/blog'],
    ],
  },
  {
    heading: 'Help',
    items: [
      ['My account',         '/account'],
      ['Track your order',   '/track'],
      ['Contact us',         '/contact'],
      ['Shipping policy',    '/shipping-policy'],
      ['Returns',            '/returns'],
      ['FAQ',                '/faq'],
    ],
  },
] as const;

const SOCIALS = [
  { label: 'Instagram', href: 'https://instagram.com/wonderherbals' },
  { label: 'YouTube',   href: 'https://youtube.com/@wonderherbals'  },
];

const linkStyle: React.CSSProperties = {
  color: '#CFE3BC',
  textDecoration: 'none',
  fontSize: 14.5,
  lineHeight: 1.4,
};

export default function Footer() {
  return (
    <div className="page-gutter" style={{ paddingBottom: 24, paddingTop: 24 }}>
      <footer
        style={{
          maxWidth: 1392,
          margin: '0 auto',
          borderRadius: 'clamp(30px, 3vw, 40px)',
          background: '#0F2616',
          color: '#CFE3BC',
          overflow: 'hidden',
          padding: 'clamp(32px, 5vw, 64px) clamp(22px, 5vw, 64px) 0',
        }}
      >
        <div className="grid grid-cols-2 lg:grid-cols-[1.5fr_1fr_1fr_1fr]" style={{ gap: 'clamp(24px, 3vw, 40px)' }}>
          <div className="col-span-2 lg:col-span-1" style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
            <img src="/images/fresh-leaf/logo-white.png" alt="Wonder Herbals, established 2009" style={{ width: 200, height: 'auto', display: 'block' }} />
            <p style={{ margin: 0, maxWidth: 340, fontSize: 15, lineHeight: 1.65, color: '#A9C495' }}>
              Single herbs, stone-crushed in Hyderabad since 2009. Pure Ayurveda for everyday life.
            </p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
              {SOCIALS.map(s => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="transition-colors hover:bg-white/15"
                  style={{
                    height: 44, padding: '0 18px', borderRadius: 9999,
                    background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.12)',
                    color: '#CFE3BC', textDecoration: 'none',
                    display: 'flex', alignItems: 'center', fontSize: 13, fontWeight: 600,
                  }}
                >
                  {s.label}
                </a>
              ))}
              <a
                href={`https://wa.me/${WHATSAPP_CONFIG.phoneNumber}?text=${encodeURIComponent(WHATSAPP_CONFIG.defaultMessage)}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  height: 44, padding: '0 18px', borderRadius: 9999,
                  background: '#8BC540', color: '#0F2616', textDecoration: 'none',
                  display: 'flex', alignItems: 'center', fontSize: 13, fontWeight: 700,
                }}
              >
                WhatsApp
              </a>
            </div>
          </div>

          {COLS.map(col => (
            <nav key={col.heading} aria-label={col.heading} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
              <span style={{ fontSize: 12, fontWeight: 700, letterSpacing: '0.14em', color: '#8BC540', textTransform: 'uppercase', marginBottom: 4 }}>
                {col.heading}
              </span>
              {col.items.map(([label, href]) => (
                <Link key={label} to={href} className="hover:!text-white transition-colors" style={linkStyle}>
                  {label}
                </Link>
              ))}
            </nav>
          ))}
        </div>

        <div
          className="flex flex-col md:flex-row"
          style={{
            marginTop: 48, padding: '20px 0',
            borderTop: '1px solid rgba(255,255,255,0.1)',
            justifyContent: 'space-between', gap: 16,
            fontSize: 12.5, color: '#93AE80',
          }}
        >
          <span style={{ maxWidth: 720, lineHeight: 1.6 }}>
            Ayurvedic products are not intended to diagnose, treat, cure or prevent any disease. Consult a physician if pregnant, nursing or under medical care.
          </span>
          <span style={{ display: 'flex', gap: 20, flexWrap: 'wrap', whiteSpace: 'nowrap' }}>
            <Link to="/privacy" style={{ ...linkStyle, fontSize: 12.5 }}>Privacy</Link>
            <Link to="/terms" style={{ ...linkStyle, fontSize: 12.5 }}>Terms</Link>
            <span>© {new Date().getFullYear()} Wonder Herbals Pvt. Ltd.</span>
          </span>
        </div>

        <div
          aria-hidden="true"
          style={{
            marginTop: 'clamp(8px, 2vw, 24px)',
            marginBottom: '-0.26em',
            fontWeight: 800,
            fontSize: 'clamp(56px, 10.6vw, 150px)',
            lineHeight: 1,
            letterSpacing: '-0.05em',
            color: '#1C3B24',
            whiteSpace: 'nowrap',
            textAlign: 'center',
            userSelect: 'none',
          }}
        >
          wonder herbals
        </div>
      </footer>
    </div>
  );
}
